import { Table } from 'antd';
import React from 'react';

import type { DetailsOfExpensesReportTableProps } from '@app/pages/Analytics/DetailsOfExpensesReport/types';
import { transformDetailsOfExpensesReportToTableData } from '@app/pages/Analytics/DetailsOfExpensesReport/utils';

const HEADER_HEIGHT = 400;

export const DetailsOfExpensesReportTable: React.FC<
  DetailsOfExpensesReportTableProps
> = ({ isLoading, tableData }) => {
  const { dataSource, columns } =
    transformDetailsOfExpensesReportToTableData(tableData);

  return (
    <Table
      bordered
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      loading={isLoading}
      className="table-border-dark"
      rowClassName={(record) =>
        record.key === 'total' ? 'cash-table-total-row' : ''
      }
      scroll={{ x: 'max-content', y: `calc(100vh - ${HEADER_HEIGHT}px)` }}
    />
  );
};
